
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-16141ba8&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./UserProfileLink.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./UserProfileLink.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-16141ba8!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./UserProfileLink.vue"),
  /* scopeId */
  "data-v-16141ba8",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./dev/src/components/UserProfileLink.vue
// module id = ./dev/src/components/UserProfileLink.vue
// module chunks = 0